﻿import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'page-not-found',
    templateUrl: 'page-not-found.component.html'
})
export class PageNotFoundComponent implements OnInit {
  code = '404';

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (!params.code) {
        return;
      }

      this.code = params.code;
    });
  }
}
